import { render, staticRenderFns } from "./Videowall.vue?vue&type=template&id=c136509e&"
import script from "./Videowall.vue?vue&type=script&lang=js&"
export * from "./Videowall.vue?vue&type=script&lang=js&"
import style0 from "./Videowall.vue?vue&type=style&index=0&id=c136509e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports